import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import CalendarData from '../components/Calendar.json'
import Spinner from '../components/Spinner'
import EventDetails from '../components/EventDetails'

export default function ViewEvent() {
    const { id } = useParams();
    const [eventData, setEventData] = useState({})
    const [loading, setLoading] = useState(true)

    const initData = function () {
        for (let i = 0; i < CalendarData.length; i++) {
            if (CalendarData[i].id == id) {
                var data = CalendarData[i]
            }
        }
        setEventData(data);
        setLoading(false);
    }

    useEffect(() => {
        initData();
    }, []);

    return (
        <div>
            <main role="main" className="flex-shrink-0 min-vh-100">
                <div className='container mb-5 py-4'>
                    <div className='row'>
                        <div className='card px-0'>
                            {
                                (loading) ? (<Spinner padding={5} />) : (<>
                                    <div className='card-header' >
                                        <h3 className='text-light'>
                                            View Event
                                        </h3>
                                    </div>
                                    <div className='card-body p-0'>
                                        <EventDetails Data={eventData} />
                                    </div>
                                </>
                                )
                            }
                        </div>

                    </div>

                </div>
            </main>
        </div >
    )
}
